import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Menu, Transition } from '@headlessui/react'
import { FiChevronDown, FiUser, FiMail, FiLogOut, FiShield } from 'react-icons/fi'
import { useAuth } from 'context/auth'
import { SUPPORT_EMAIL } from './nav-config'

const focusRing = 'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ember focus-visible:tw-ring-offset-2'
const itemClass = (active) => `tw-flex tw-w-full tw-items-center tw-gap-2 tw-rounded-[10px] tw-px-3 tw-py-2 tw-text-left tw-text-[14px] tw-text-ink ${active ? 'tw-bg-sand' : ''}`

const initialsFor = (user) => {
  const initials = `${user?.firstName?.[0] || ''}${user?.lastName?.[0] || ''}`
  return (initials || user?.email?.[0] || '?').toUpperCase()
}

function UserMenu() {
  const { currentUser, logout } = useAuth()
  const fullName = [currentUser?.firstName, currentUser?.lastName].filter(Boolean).join(' ') || 'Super Admin'

  return (
    <Menu as='div' className='tw-relative tw-min-w-0'>
      <Menu.Button aria-label='Account menu' className={`tw-flex tw-min-w-0 tw-items-center tw-gap-2 tw-rounded-[10px] tw-p-1 hover:tw-bg-sand ${focusRing}`}>
        <span className='tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-ember tw-text-[13px] tw-font-semibold tw-text-white'>{initialsFor(currentUser)}</span>
        <span className='tw-hidden tw-min-w-0 tw-flex-col tw-text-left sm:tw-flex'>
          <span className='tw-truncate tw-text-[14px] tw-font-semibold tw-text-ink'>{fullName}</span>
          <span className='tw-truncate tw-text-[12px] tw-text-inkSoft'>{currentUser?.email}</span>
        </span>
        <FiChevronDown aria-hidden='true' className='tw-hidden tw-h-4 tw-w-4 tw-text-inkSoft sm:tw-block' />
      </Menu.Button>
      <Transition as={Fragment} enter='tw-transition tw-duration-100 tw-ease-out' enterFrom='tw-opacity-0 tw-scale-95' enterTo='tw-opacity-100 tw-scale-100' leave='tw-transition tw-duration-75 tw-ease-in' leaveFrom='tw-opacity-100 tw-scale-100' leaveTo='tw-opacity-0 tw-scale-95'>
        <Menu.Items className='tw-absolute tw-right-0 tw-z-50 tw-mt-2 tw-w-64 tw-max-w-[calc(100vw-2rem)] tw-rounded-2xl tw-border tw-border-line tw-bg-white tw-p-2 tw-shadow-pop focus:tw-outline-none'>
          <div className='tw-border-b tw-border-line tw-px-3 tw-pb-3 tw-pt-1'>
            <div className='tw-mb-1 tw-flex tw-items-center tw-gap-2 tw-text-[12px] tw-font-semibold tw-uppercase tw-tracking-[0.12em] tw-text-emberText'><FiShield /> Platform admin</div>
            <p className='tw-truncate tw-text-[14px] tw-font-semibold tw-text-ink'>{fullName}</p>
            <p className='tw-truncate tw-text-[12px] tw-text-inkSoft'>{currentUser?.email}</p>
          </div>
          <Menu.Item>{({ active }) => <Link to='/account' className={itemClass(active)}><FiUser className='tw-h-4 tw-w-4 tw-text-inkSoft' />My account</Link>}</Menu.Item>
          <Menu.Item>{({ active }) => <a href={`mailto:${SUPPORT_EMAIL}`} className={itemClass(active)}><FiMail className='tw-h-4 tw-w-4 tw-text-inkSoft' />Email support</a>}</Menu.Item>
          <Menu.Item>{({ active }) => <button type='button' onClick={logout} className={itemClass(active)}><FiLogOut className='tw-h-4 tw-w-4 tw-text-inkSoft' />Log out</button>}</Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default UserMenu
